var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-4 font-bold"},[_vm._v("My Invoices")]),_vm._l((_vm.invoices),function(invoice,i){return _c('div',{key:i},[_c('InvoiceEntry',{attrs:{"invoice":invoice}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }